// Datas no padrão brasileiro (dd/mm/aaaa e dd/mm/aaaa hh:mm).
// Datas sem fuso ("2026-10-14" ou "2026-10-14T00:00:00") são lidas campo a campo: new Date() as trataria como UTC
// ou horário local conforme o formato e poderia mostrar o dia anterior.

const ISO_SEM_FUSO = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?)?$/;
const JA_BRASILEIRA = /^(\d{2}\/\d{2}\/\d{4})(?:\s+(\d{1,2}):(\d{2})(?::\d{2})?)?$/;

const pad = valor => String(valor).padStart(2, '0');

const decompor = valor => {
  if (valor === null || valor === undefined || valor === '') return null;
  const texto = String(valor).trim();

  const brasileira = JA_BRASILEIRA.exec(texto);
  if (brasileira) return { data: brasileira[1], hora: brasileira[2] ? `${pad(brasileira[2])}:${brasileira[3]}` : null };

  const iso = ISO_SEM_FUSO.exec(texto);
  if (iso) return { data: `${iso[3]}/${iso[2]}/${iso[1]}`, hora: iso[4] ? `${iso[4]}:${iso[5]}` : null };

  // Com fuso (Z ou -03:00): converte para o horário local de quem está vendo.
  const data = new Date(texto);
  if (Number.isNaN(data.getTime())) return null;
  return { data: `${pad(data.getDate())}/${pad(data.getMonth() + 1)}/${data.getFullYear()}`, hora: `${pad(data.getHours())}:${pad(data.getMinutes())}` };
};

export const formatarDataBr = valor => decompor(valor)?.data || '';

export const formatarDataHoraBr = valor => {
  const partes = decompor(valor);
  if (!partes) return '';
  return partes.hora ? `${partes.data} ${partes.hora}` : partes.data;
};

// Junta a data (sem hora) com um horário "HH:mm" à parte, como Saída CDH + término do carregamento.
export const juntarDataHoraBr = (data, hora) => {
  const dia = formatarDataBr(data);
  if (!dia) return '';
  const horario = /^(\d{1,2}):(\d{2})/.exec(String(hora || ''));
  return horario ? `${dia} ${pad(horario[1])}:${horario[2]}` : dia;
};
